import { render, staticRenderFns } from "./SelectRepairs.vue?vue&type=template&id=4c8cb247&scoped=true&"
import script from "./SelectRepairs.vue?vue&type=script&lang=js&"
export * from "./SelectRepairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cb247",
  null
  
)

export default component.exports